<div id="contactDialog">
	<p-dialog
		[header]="'聯絡我們'"
		[(visible)]="contactFormShow"
		[style]="{ width: '90%', 'max-width': '50rem' }"
		[modal]="true"
		[dismissableMask]="true"
		[draggable]="false"
		[showHeader]="true"
		[closable]="true"
		(onHide)="contactForm.reset(); contactFormShow = false; contactFormShowChange.emit(this.contactFormShow)"
	>
		<ng-template pTemplate="content">
			<p class="intro">請在下面的表格中填寫您的聯繫方式。我們將盡快答覆您的詢問或問題。</p>
			<form [formGroup]="contactForm" class="row">
				<div class="form-group d-flex col-12 align-items-center mb-3">
					<label class="mb-0">
						<span class="required">*</span>
						<span>姓名</span>
					</label>
					<div class="col pr-0 field-cus">
						<div class="d-flex">
							<input
								class="mr-2"
								pInputText
								type="text"
								placeholder="名字"
								formControlName="FirstName"
								id="firstName"
							/>

							<input
								pInputText
								type="text"
								placeholder="姓氏"
								formControlName="FamilyName"
								id="familyName"
							/>
						</div>
					</div>
				</div>

				<div class="form-group d-flex col-12 align-items-center mb-3">
					<label class="mb-0">
						<span class="required hidden">*</span>
						<span>公司</span>
					</label>
					<div class="col pr-0 field-cus">
						<input pInputText type="text" placeholder="" formControlName="Company" id="company" />
					</div>
				</div>
				<div class="form-group d-flex col-12 align-items-center mb-3">
					<label class="mb-0">
						<span class="required hidden">*</span>
						<span>職稱</span>
					</label>
					<div class="col pr-0 field-cus">
						<input pInputText type="text" placeholder="" formControlName="JobTitle" id="jobTitle" />
					</div>
				</div>
				<div class="form-group d-flex col-12 align-items-center mb-3">
					<label class="mb-0">
						<span class="required">*</span>
						<span>電子郵件</span>
					</label>
					<div class="col pr-0 field-cus">
						<input pInputText type="text" placeholder="" formControlName="Mail" id="mail" />
					</div>
				</div>
				<div class="form-group d-flex col-12 align-items-center mb-3">
					<label class="mb-0">
						<span class="required hidden">*</span>
						<span>電話</span>
					</label>
					<div class="col pr-0 field-cus">
						<input pInputText type="text" placeholder="" formControlName="Phone" id="phone" />
					</div>
				</div>
				<div class="form-group d-flex col-12 align-items-center mb-3">
					<label class="mb-0">
						<span class="required">*</span>
						<span>主旨</span>
					</label>
					<div class="col pr-0 field-cus">
						<input pInputText type="text" placeholder="" formControlName="Subject" id="subject" />
					</div>
				</div>

				<div class="form-group d-flex col-12">
					<label class="mb-0">
						<span class="required hidden">*</span>
						<span>問題與反映</span>
					</label>
					<div class="col pr-0 field-cus">
						<textarea
							pInputText
							type="text"
							placeholder=""
							formControlName="Content"
							id="content"
							rows="5"
						></textarea>
					</div>
				</div>
			</form>
			<div class="d-flex justify-content-center align-items-center mt-4">
				<button type="button" class="submit-btn" (click)="onSubmitContact()">送出</button>
			</div>
		</ng-template>
	</p-dialog>
</div>
